import {
  mapTelemetryPopupRows,
  type MapTelemetryPopupFacts,
} from '@/utils/map-telemetry-popup-rows';

export type TrackVertexPopupFacts = {
  timestampSec: number;
  battery: number | null;
  /** null / omitted → row not drawn (legacy API without fix_type). */
  fixTypeCode?: number | null;
  /** null / omitted → row not drawn (legacy API without accuracy). */
  accuracyMeters?: number | null;
};

/** Lazy popup HTML for a shipment track vertex. */
export function formatTrackVertexPopup(facts: TrackVertexPopupFacts): string {
  const telemetry: MapTelemetryPopupFacts = {
    timestampSec: facts.timestampSec,
    battery: facts.battery,
    fixTypeCode: facts.fixTypeCode,
    accuracyMeters: facts.accuracyMeters,
  };
  const rows = mapTelemetryPopupRows(telemetry, { emphasizeTime: true });

  if (rows.length === 0) {
    return '—';
  }

  return `<div class="gpx-track-vertex-popup">${rows.join('')}</div>`;
}
